import config from '@/config'
import { useBeforeUnload, useBlocker } from 'react-router-dom'

// @todo React Router v6 broke this - needs to be updated
export const useGuardExit = (conditionFn, message) => {
    
    useBeforeUnload(event => {
        if (conditionFn())
            event.preventDefault()
    })
    
    if (config.enableDataRouter) {
        
        // xxx-eslint-disable-next-line react-compiler/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const blocker = useBlocker(conditionFn)
        
        if (blocker.state === 'blocked') {
            if (confirm(message))
                blocker.proceed()
            else
                blocker.reset()
        }
    }
    
}
